import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Card,
  CardContent,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Alert,
  AlertTitle,
  Avatar,
  Menu,
  Tooltip,
  Fab,
  Badge,
  Switch,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  LinearProgress
} from '@mui/material';
import {
  Add as AddIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Security as SecurityIcon,
  Business as BusinessIcon,
  Support as SupportIcon,
  WorkOutline as WorkOutlineIcon,
  LocationCity as LocationCityIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Today as TodayIcon,
  VerifiedUser as VerifiedUserIcon,
  Block as BlockIcon,
  TrendingUp as TrendingUpIcon,
  Group as GroupIcon
} from '@mui/icons-material';

const AdminUsers = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  // Mock data for users
  const [users, setUsers] = useState([
    {
      id: 1,
      name: 'করিম উদ্দিন',
      email: 'karim@example.com',
      phone: '01712345678',
      role: 'দোকান মালিক',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০৫-১৫',
      lastActive: '২ ঘন্টা আগে',
      location: 'ঢাকা',
      totalOrders: 156,
      avatar: 'K'
    },
    {
      id: 2,
      name: 'ফাতেমা খাতুন',
      email: 'fatema@example.com',
      phone: '01812345679',
      role: 'কাস্টমার',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০৬-২০',
      lastActive: '১ দিন আগে',
      location: 'চট্টগ্রাম',
      totalOrders: 89,
      avatar: 'ফ'
    },
    {
      id: 3,
      name: 'আহমেদ হাসান',
      email: 'ahmed@grameenbazar.com',
      phone: '01912345680',
      role: 'অ্যাডমিন',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০১-১০',
      lastActive: 'অনলাইন',
      location: 'ঢাকা',
      totalOrders: 0,
      avatar: 'আ'
    },
    {
      id: 4,
      name: 'সালেহা বেগম',
      email: 'saleha@example.com',
      phone: '01612345681',
      role: 'কাস্টমার',
      status: 'অপেক্ষমান',
      verified: false,
      joinDate: '২০২৩-০৮-২৫',
      lastActive: '৩ দিন আগে',
      location: 'সিলেট',
      totalOrders: 12,
      avatar: 'স'
    },
    {
      id: 5,
      name: 'রহিম আলী',
      email: 'rahim@example.com',
      phone: '01512345682',
      role: 'দোকান মালিক',
      status: 'নিষ্ক্রিয়',
      verified: true,
      joinDate: '২০২৩-০৩-১২',
      lastActive: '১ সপ্তাহ আগে',
      location: 'রাজশাহী',
      totalOrders: 234,
      avatar: 'র'
    },
    {
      id: 6,
      name: 'নাসির উদ্দিন',
      email: 'nasir@grameenbazar.com',
      phone: '01412345683',
      role: 'সাপোর্ট স্টাফ',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০৪-০৮',
      lastActive: '১ ঘন্টা আগে',
      location: 'ঢাকা',
      totalOrders: 0,
      avatar: 'ন'
    },
    {
      id: 7,
      name: 'শামীম আক্তার',
      email: 'shamim@grameenbazar.com',
      phone: '01312345684',
      role: 'ইমপ্লয়ি',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০৭-১৮',
      lastActive: '৪ ঘন্টা আগে',
      location: 'চট্টগ্রাম',
      totalOrders: 0,
      avatar: 'শ'
    },
    {
      id: 8,
      name: 'মোঃ জাকির হোসেন',
      email: 'zakir@grameenbazar.com',
      phone: '01212345685',
      role: 'উপজেলা এ্যাডমিন',
      status: 'সক্রিয়',
      verified: true,
      joinDate: '২০২৩-০২-১৪',
      lastActive: 'অনলাইন',
      location: 'কুমিল্লা',
      totalOrders: 0,
      avatar: 'জ'
    }
  ]);

  const roles = ['কাস্টমার', 'দোকান মালিক', 'অ্যাডমিন', 'সাপোর্ট স্টাফ', 'ইমপ্লয়ি', 'উপজেলা এ্যাডমিন'];

  // Statistics
  const userStats = {
    totalUsers: users.length,
    activeUsers: users.filter(u => u.status === 'সক্রিয়').length,
    pendingUsers: users.filter(u => u.status === 'অপেক্ষমান').length,
    verifiedUsers: users.filter(u => u.verified).length,
    customersCount: users.filter(u => u.role === 'কাস্টমার').length,
    storeOwnersCount: users.filter(u => u.role === 'দোকান মালিক').length,
    adminCount: users.filter(u => u.role === 'অ্যাডমিন').length,
    staffCount: users.filter(u => ['সাপোর্ট স্টাফ', 'ইমপ্লয়ি', 'উপজেলা এ্যাডমিন'].includes(u.role)).length
  };

  const handleAddUser = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleActionMenuOpen = (event, user) => {
    setActionMenuAnchor(event.currentTarget);
    setSelectedUser(user);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
    setSelectedUser(null);
  };

  const handleStatusChange = (userId, newStatus) => {
    setUsers(users.map(user => 
      user.id === userId ? { ...user, status: newStatus } : user
    ));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'সক্রিয়': return 'success';
      case 'অপেক্ষমান': return 'warning';
      case 'নিষ্ক্রিয়': return 'error';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'সক্রিয়': return <CheckCircleIcon />;
      case 'অপেক্ষমান': return <PendingIcon />;
      case 'নিষ্ক্রিয়': return <CancelIcon />;
      default: return <PendingIcon />;
    }
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'অ্যাডমিন': return <AdminPanelSettingsIcon />;
      case 'দোকান মালিক': return <BusinessIcon />;
      case 'কাস্টমার': return <PersonIcon />;
      case 'সাপোর্ট স্টাফ': return <SupportIcon />;
      case 'ইমপ্লয়ি': return <WorkOutlineIcon />;
      case 'উপজেলা এ্যাডমিন': return <LocationCityIcon />;
      default: return <PersonIcon />;
    }
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'অ্যাডমিন': return 'error';
      case 'দোকান মালিক': return 'primary';
      case 'কাস্টমার': return 'success';
      case 'সাপোর্ট স্টাফ': return 'info';
      case 'ইমপ্লয়ি': return 'secondary';
      case 'উপজেলা এ্যাডমিন': return 'warning';
      default: return 'default';
    }
  };

  const filteredUsers = users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         user.phone.includes(searchTerm);
    
    const matchesRole = filterRole === 'all' || user.role === filterRole;
    const matchesStatus = filterStatus === 'all' || user.status === filterStatus;
    
    return matchesSearch && matchesRole && matchesStatus;
  });

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
            <PeopleIcon sx={{ fontSize: 40 }} />
            ব্যবহারকারী পরিচালনা
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            গ্রামীণবাজারের সকল ব্যবহারকারী পরিচালনা - নিবন্ধন, যাচাইকরণ এবং অনুমতি
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddUser}
          sx={{
            background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
            color: 'white',
            px: 3,
            py: 1.5,
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            }
          }}
        >
          নতুন ব্যবহারকারী যোগ করুন
        </Button>
      </Box>

      {/* Info Alert */}
      <Alert severity="info" sx={{ mb: 3 }} icon={<SecurityIcon />}>
        <AlertTitle>ব্যবহারকারী পরিচালনা সম্পর্কে</AlertTitle>
        এই সিস্টেমের মাধ্যমে সকল ব্যবহারকারীর অ্যাকাউন্ট, ভূমিকা এবং অনুমতি পরিচালনা করুন। ব্যবহারকারীদের কার্যক্রম মনিটর করুন এবং প্রয়োজনীয় পদক্ষেপ নিন।
      </Alert>

      {/* Statistics Overview */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <GroupIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{userStats.totalUsers}</Typography>
                  <Typography variant="body2">মোট ব্যবহারকারী</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <CheckCircleIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{userStats.activeUsers}</Typography>
                  <Typography variant="body2">সক্রিয় ব্যবহারকারী</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <VerifiedUserIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{userStats.verifiedUsers}</Typography>
                  <Typography variant="body2">যাচাইকৃত</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
            <CardContent sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                  <PendingIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{userStats.pendingUsers}</Typography>
                  <Typography variant="body2">অপেক্ষমান</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* User Role Distribution */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                ব্যবহারকারীর ভূমিকা বিতরণ
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={6} md={3}>
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <PersonIcon sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>{userStats.customersCount}</Typography>
                    <Typography variant="body2" color="text.secondary">কাস্টমার</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <BusinessIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>{userStats.storeOwnersCount}</Typography>
                    <Typography variant="body2" color="text.secondary">দোকান মালিক</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <AdminPanelSettingsIcon sx={{ fontSize: 40, color: 'error.main', mb: 1 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>{userStats.adminCount}</Typography>
                    <Typography variant="body2" color="text.secondary">অ্যাডমিন</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <SupportIcon sx={{ fontSize: 40, color: 'info.main', mb: 1 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>{userStats.staffCount}</Typography>
                    <Typography variant="body2" color="text.secondary">স্টাফ</Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                দৈনিক কার্যক্রম
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2">আজকের নতুন সদস্য</Typography>
                  <Chip label="৮" color="success" size="small" />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2">অনলাইন ব্যবহারকারী</Typography>
                  <Chip label="২৪" color="info" size="small" />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2">পেন্ডিং যাচাইকরণ</Typography>
                  <Chip label="৩" color="warning" size="small" />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2">মাসিক বৃদ্ধি</Typography>
                  <Chip label="+১৫%" color="success" size="small" />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search and Filter Bar */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              placeholder="নাম, ইমেইল বা ফোন নম্বর অনুসন্ধান করুন..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>ভূমিকা ফিল্টার</InputLabel>
              <Select
                value={filterRole}
                onChange={(e) => setFilterRole(e.target.value)}
                label="ভূমিকা ফিল্টার"
              >
                <MenuItem value="all">সব ভূমিকা</MenuItem>
                {roles.map((role) => (
                  <MenuItem key={role} value={role}>{role}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>অবস্থা ফিল্টার</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="অবস্থা ফিল্টার"
              >
                <MenuItem value="all">সব অবস্থা</MenuItem>
                <MenuItem value="সক্রিয়">সক্রিয়</MenuItem>
                <MenuItem value="অপেক্ষমান">অপেক্ষমান</MenuItem>
                <MenuItem value="নিষ্ক্রিয়">নিষ্ক্রিয়</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button 
              variant="outlined" 
              fullWidth
              onClick={() => {
                setSearchTerm('');
                setFilterRole('all');
                setFilterStatus('all');
              }}
            >
              রিসেট
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Users Table */}
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>ব্যবহারকারী</TableCell>
                <TableCell>যোগাযোগ</TableCell>
                <TableCell>ভূমিকা</TableCell>
                <TableCell>অবস্থান</TableCell>
                <TableCell align="center">অর্ডার</TableCell>
                <TableCell align="center">অবস্থা</TableCell>
                <TableCell align="center">যাচাই</TableCell>
                <TableCell align="center">সর্বশেষ সক্রিয়</TableCell>
                <TableCell align="center">অ্যাকশন</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.map((user) => (
                <TableRow key={user.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.light' }}>
                        {user.avatar}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          {user.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          ID: {user.id} | যোগদান: {user.joinDate}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <EmailIcon sx={{ fontSize: 14 }} />
                        {user.email}
                      </Typography>
                      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                        <PhoneIcon sx={{ fontSize: 14 }} />
                        {user.phone}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={user.role} 
                      color={getRoleColor(user.role)}
                      icon={getRoleIcon(user.role)}
                      size="small"
                      sx={{ borderRadius: 1 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <LocationCityIcon sx={{ fontSize: 14 }} />
                      {user.location}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {user.totalOrders}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={user.status}
                      color={getStatusColor(user.status)}
                      size="small"
                      icon={getStatusIcon(user.status)}
                      sx={{ borderRadius: 1 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {user.verified ? (
                      <Chip label="যাচাইকৃত" color="success" size="small" variant="outlined" />
                    ) : (
                      <Chip label="অযাচাইকৃত" color="warning" size="small" variant="outlined" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" color="text.secondary">
                      {user.lastActive}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={(e) => handleActionMenuOpen(e, user)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Action Menu */}
      <Menu
        anchorEl={actionMenuAnchor}
        open={Boolean(actionMenuAnchor)}
        onClose={handleActionMenuClose}
      >
        <MenuItem onClick={handleActionMenuClose}>
          <VisibilityIcon sx={{ mr: 1, fontSize: 18 }} />
          বিস্তারিত দেখুন
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose}>
          <EditIcon sx={{ mr: 1, fontSize: 18 }} />
          সম্পাদনা করুন
        </MenuItem>
        <MenuItem onClick={() => {
          if (selectedUser) {
            handleStatusChange(selectedUser.id, selectedUser.status === 'সক্রিয়' ? 'নিষ্ক্রিয়' : 'সক্রিয়');
          }
          handleActionMenuClose();
        }}>
          {selectedUser?.status === 'সক্রিয়' ? <BlockIcon /> : <CheckCircleIcon />}
          <Typography sx={{ ml: 1, fontSize: 14 }}>
            {selectedUser?.status === 'সক্রিয়' ? 'নিষ্ক্রিয় করুন' : 'সক্রিয় করুন'}
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose} sx={{ color: 'error.main' }}>
          <DeleteIcon sx={{ mr: 1, fontSize: 18 }} />
          মুছে ফেলুন
        </MenuItem>
      </Menu>

      {/* Add User Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{ 
          background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)', 
          color: 'white' 
        }}>
          নতুন ব্যবহারকারী যোগ করুন
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="পূর্ণ নাম"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="ইমেইল ঠিকানা"
                variant="outlined"
                type="email"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="মোবাইল নম্বর"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>ব্যবহারকারীর ভূমিকা</InputLabel>
                <Select label="ব্যবহারকারীর ভূমিকা">
                  {roles.map((role) => (
                    <MenuItem key={role} value={role}>{role}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="পাসওয়ার্ড"
                variant="outlined"
                type="password"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="পাসওয়ার্ড নিশ্চিত করুন"
                variant="outlined"
                type="password"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="অবস্থান/এলাকা"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>প্রাথমিক অবস্থা</InputLabel>
                <Select label="প্রাথমিক অবস্থা" defaultValue="সক্রিয়">
                  <MenuItem value="সক্রিয়">সক্রিয়</MenuItem>
                  <MenuItem value="অপেক্ষমান">অপেক্ষমান</MenuItem>
                  <MenuItem value="নিষ্ক্রিয়">নিষ্ক্রিয়</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch defaultChecked />}
                label="ইমেইল যাচাইকরণ হিসেবে চিহ্নিত করুন"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch />}
                label="স্বাগতম ইমেইল পাঠান"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleCloseDialog} variant="outlined">
            বাতিল করুন
          </Button>
          <Button 
            onClick={handleCloseDialog} 
            variant="contained"
            sx={{
              background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
              color: 'white',
              '&:hover': {
                background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
              }
            }}
          >
            ব্যবহারকারী যোগ করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="add user"
        onClick={handleAddUser}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
          }
        }}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default AdminUsers;

